import templateBasicPriceList from './template-basic-price-list.js';

export default [
  ...templateBasicPriceList,
];
